import * as React from "react";
import { t } from "../../i18n/util";
import { API } from "../../network/API";
import { GetUsersResponseUsers } from "../../network/APITypes";
import { generalStore } from "../../stores/GeneralStore";

export const useUsers = () => {
    const [users, setUsers] = React.useState<GetUsersResponseUsers[] | undefined>(undefined);

    React.useEffect(() => {
        const load = async () => {
            try {
                generalStore.isLoading = true;
                const response = await API.getUsers();

                if (response) {
                    setUsers(response.users);
                }
            } catch (err) {
                generalStore.setError(t("error.loadUsers"), err);
            } finally {
                generalStore.isLoading = false;
            }
        };
        load();
    }, []);

    return users;
};
